module.exports = __webpack_public_path__ + "img/Wales.14a42e88.png";